module.exports = __webpack_public_path__ + "img/chariatble-colombus.e85cbbe0.png";